import { render } from "./repairStatistics.vue?vue&type=template&id=112608ea&scoped=true"
import script from "./repairStatistics.vue?vue&type=script&lang=js"
export * from "./repairStatistics.vue?vue&type=script&lang=js"

import "./repairStatistics.vue?vue&type=style&index=0&id=112608ea&lang=less&scoped=true"

import exportComponent from "D:\\work\\ask_cloud\\QC\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-112608ea"]])

export default __exports__